import { bffRetailMedia } from '~/middlewares/axios'

const baseURL = `/campaign`

export const updateDestinationUrlsService = ({
  id,
  body
}: UpdateDestinationUrlRequest) =>
  bffRetailMedia.patch(`${baseURL}/destination-urls/${id}`, body)

export const updateNetworkDestinationUrlsService = ({
  id,
  body
}: UpdateNetworkDestinationUrlRequest) =>
  bffRetailMedia.put(`${baseURL}/network/destination-urls/${id}`, body)
